import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const portfolio = [{
  id: 2,
  title: 'Platinum Ice',
  image: 'https://cdn.magicpatterns.com/uploads/f4Jdi4EB7dKeZRtxTdVi2L/⚪️🎨💈✂️_framesiurguay.webp',
  className: ''
}, {
  id: 3,
  title: 'Cyber Blue',
  image: 'https://cdn.magicpatterns.com/uploads/3pXCkBSKwPznXsZshCNdmZ/⚪️🔹🇺🇾💈.webp',
  className: ''
}, {
  id: 4,
  title: 'Blue Streak Mullet',
  image: 'https://cdn.magicpatterns.com/uploads/9GZaDTC98FDnNzDqhJDfVK/El_corte_de_tu_suenos_lo_tenes_en_barberianinja2.0_🥷🙏🏼✂️_manana_nueva_peli_📽️🎞️_roodrigos.webp',
  className: ''
}, {
  id: 5,
  title: 'Taper Fade',
  image: 'https://cdn.magicpatterns.com/uploads/46aXkGSCXftQ8X77yUYL9x/Taper_Fade_✂️_lucaaasmz_😎🔥_(1).webp',
  className: ''
}];
export function ColoristShowcase() {
  return <section id="color" className="py-32 bg-[#050505]" data-id="element-105" data-mp="1ibxn7vqalqj3">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-106" data-mp="1ib4l582a3p7a">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-107" data-mp="1p05s1fbpwsv0">
          <div data-id="element-108" data-mp="1t294a667o1hc">
            <motion.h2 initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} className="font-display text-5xl md:text-7xl mb-4" data-id="element-109" data-mp="1t0po0fkk1qfk">
              Especialista en{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-violet to-fuchsia-500" data-id="element-110" data-mp="1acay5vlz4igc">
                Color.
              </span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-gray-400 text-lg max-w-md" data-id="element-111" data-mp="11a1of7yj4t40">
              Trabajos de colorimetría vibrantes, platinados impecables y
              diseños de autor que rompen las reglas.
            </motion.p>
          </div>

          <motion.a initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} href="https://www.instagram.com/barberianinja2.0" target="_blank" rel="noreferrer" className="hidden md:inline-flex px-6 py-3 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors text-sm font-medium" data-id="element-112" data-mp="2fay238qrztix">
            Ver más en Instagram
          </motion.a>
        </div>

        {/* Bento Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 auto-rows-[250px] md:auto-rows-[300px]" data-id="element-113" data-mp="3qwd6ndr2gy0j">
          {portfolio.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`group relative rounded-3xl overflow-hidden bg-white/5 border border-white/10 ${item.className}`} data-id="element-114" data-mp="729q3nevg0ll" data-mpi={index}>
              {item.type === 'video' ? <div className="w-full h-full bg-black flex items-center justify-center" data-id="element-115" data-mp="zrgxzd07u2ji">
                  <video src={item.image} loop muted playsInline preload="none" width="600" height="600" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" onMouseEnter={e => e.currentTarget.play()} onMouseLeave={e => e.currentTarget.pause()} data-id="element-116" data-mp="ztb9k0plkiax" />
                </div> : <img src={item.image} alt={item.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" loading="lazy" decoding="async" width="600" height="600" data-id="element-117" data-mp="2b91fyegyvttr" />}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-60 transition-opacity duration-300" data-id="element-118" data-mp="1rk0r0qa3bk2e" />

              <div className="absolute bottom-6 left-6 right-6" data-id="element-119" data-mp="37ztzjm34040a">
                <div className="inline-block px-4 py-2 rounded-full bg-black/50 backdrop-blur-md border border-white/10 text-sm font-medium text-white transform translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300" data-id="element-120" data-mp="32yecjohdfnf9">
                  {item.title}
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-121" data-mp="36hwqh0peohtg">
          <a href="https://www.instagram.com/barberianinja2.0" target="_blank" rel="noreferrer" className="inline-flex px-6 py-3 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors text-sm font-medium w-full justify-center" data-id="element-122" data-mp="3u6fuh41fa8fq">
            Ver más en Instagram
          </a>
        </div>
      </div>
    </section>;
}